import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { SxProps, Theme } from '@mui/material/styles';

interface GenericDateTimePickerProps {
  value: number | null;
  onChange: (newValue: number | null) => void;
  label: string;
  required?: boolean;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  maxDateAndTime?: Date;
}

export const DateTimePicker: React.FC<GenericDateTimePickerProps> = ({
  value,
  onChange,
  label,
  required = false,
  size = 'small',
  sx,
  maxDateAndTime,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const internalValue = value ? dayjs(value) : null;

  const handleInternalChange = (newDayjsValue: Dayjs | null) => {
    onChange(newDayjsValue ? newDayjsValue.valueOf() : null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDateTimePicker
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        label={label}
        value={internalValue}
        onChange={handleInternalChange}
        maxDateTime={maxDateAndTime ? dayjs(maxDateAndTime) : undefined}
        slotProps={{
          textField: {
            onClick: () => setIsOpen(true),
            required,
            fullWidth: true,
            size,
            variant: 'outlined',
            sx,
          },
        }}
      />
    </LocalizationProvider>
  );
};
